import { render, staticRenderFns } from "./section-last-posts.vue?vue&type=template&id=9797d340&scoped=true&"
import script from "./section-last-posts.vue?vue&type=script&lang=js&"
export * from "./section-last-posts.vue?vue&type=script&lang=js&"
import style0 from "./section-last-posts.vue?vue&type=style&index=0&id=9797d340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9797d340",
  null
  
)

export default component.exports